import { Action, isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

export const Message = {
    SUCCESS: 'Operation succeeded',
    ERROR: 'Occurs unexpected error. Verify if you provide correct data or please contact with administrator'
};

const SUCCESS_MUTATION = 'executeMutation/fulfilled';

const shouldDisplaySuccess = (action: Action) => action.type.endsWith(SUCCESS_MUTATION);

export const displayMessage: Middleware = () => next => action => {
    //display success for 'POST', 'PUT' and 'DELETE' operations
    if (shouldDisplaySuccess(action)) {
        toast.success(Message.SUCCESS);
    }

    if (isRejectedWithValue(action)) {
        //display error message
        toast.error(Message.ERROR);
    }
    return next(action);
};